export default function ExpiredCountdown() {
  const borderStyle = {
    border: "2px solid rgb(0, 0, 0)",
    marginRight: "0px",
  };

  return (
    <>
      <div className="_qWTcH _1tbqx TradeCountdown_flipClockCountdown__8deDA">
        <div className="_3cpN7">
          <div className="_2aOn7">Days</div>
          <div className="_2EBbg" style={borderStyle}>
            <div className="_SKh-V">0</div>
            <div className="_106d2">0</div>
            <div className="_3luxx">
              <div className="_2v-d4 _1GZQ7">0</div>
              <div className="_2v-d4 _3AVXa">0</div>
            </div>
          </div>
          <div className="_2EBbg" style={borderStyle}>
            <div className="_SKh-V">0</div>
            <div className="_106d2">0</div>
            <div className="_3luxx">
              <div className="_2v-d4 _1GZQ7">0</div>
              <div className="_2v-d4 _3AVXa">0</div>
            </div>
          </div>
        </div>
        <div className="_2hRXr"></div>
        <div className="_3cpN7">
          <div className="_2aOn7">Hrs</div>
          <div className="_2EBbg" style={borderStyle}>
            <div className="_SKh-V">0</div>
            <div className="_106d2">0</div>
            <div className="_3luxx">
              <div className="_2v-d4 _1GZQ7">0</div>
              <div className="_2v-d4 _3AVXa">0</div>
            </div>
          </div>
          <div className="_2EBbg" style={borderStyle}>
            <div className="_SKh-V">0</div>
            <div className="_106d2">0</div>
            <div className="_3luxx">
              <div className="_2v-d4 _1GZQ7">0</div>
              <div className="_2v-d4 _3AVXa">0</div>
            </div>
          </div>
        </div>
        <div className="_2hRXr"></div>
        <div className="_3cpN7">
          <div className="_2aOn7">Mins</div>
          <div className="_2EBbg" style={borderStyle}>
            <div className="_SKh-V">0</div>
            <div className="_106d2">0</div>
            <div className="_3luxx">
              <div className="_2v-d4 _1GZQ7">0</div>
              <div className="_2v-d4 _3AVXa">0</div>
            </div>
          </div>
          <div className="_2EBbg" style={borderStyle}>
            <div className="_SKh-V">0</div>
            <div className="_106d2">0</div>
            <div className="_3luxx">
              <div className="_2v-d4 _1GZQ7">0</div>
              <div className="_2v-d4 _3AVXa">0</div>
            </div>
          </div>
        </div>
        <div className="_2hRXr"></div>
        <div className="_3cpN7">
          <div className="_2aOn7">Secs</div>
          <div className="_2EBbg" style={borderStyle}>
            <div className="_SKh-V">0</div>
            <div className="_106d2">0</div>
            <div className="_3luxx">
              <div className="_2v-d4 _1GZQ7">0</div>
              <div className="_2v-d4 _3AVXa">0</div>
            </div>
          </div>
          <div className="_2EBbg" style={borderStyle}>
            <div className="_SKh-V">0</div>
            <div className="_106d2">0</div>
            <div className="_3luxx _2kgZC">
              <div className="_2v-d4 _1GZQ7">0</div>
              <div className="_2v-d4 _3AVXa">0</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
